import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  BcCircleLoadingComponent,
  BcCircleLoadingModule,
} from '@bancolombia/design-system-web/bc-circle-loading';
import { LoadingService } from '@shared/services/loading.service';
import { delay } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterModule, BcCircleLoadingModule],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  @ViewChild(BcCircleLoadingComponent, { static: false })
  bcCircleLoading!: BcCircleLoadingComponent;
  loadingService = inject(LoadingService);

  title = 'interativos';
  circleLoadingText = 'Cargando...';
  circleLoadingAriaLabel = '';
  loaderSpeed = '0.5';

  ngOnInit(): void {
    this.litenToLoading();
  }

  litenToLoading(): void {
    this.loadingService.loadingSub.pipe(delay(100)).subscribe((loading) => {
      if (loading) {
        this.bcCircleLoading.showCircleLoading();
      } else {
        this.bcCircleLoading.hideCircleLoading();
      }
    });
  }
}
